var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.clauses),function(item){return _c('a',{key:item.clauseName,staticClass:"link_pdf",attrs:{"href":item.clauseUrl}},[_vm._v(_vm._s(item.clauseName))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }